module.exports = __webpack_public_path__ + "static/img/FDoctor.102e987.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/FDoctor.png
// module id = WE8S
// module chunks = 3